import { jsonApi } from '../http-request';

export const SESSION = {
  SET: 'SESSION_SET',
  CLEAR: 'SESSION_CLEAR',
};

export const actions = jsonApi.createUpdResourceFacade('sessions');

const SIGN_UP = 'signup';
actions.signUp = body => actions.action(SIGN_UP, body);
actions.isSignUp = actions.isAction(SIGN_UP);

actions.set = payload => ({
  type: SESSION.SET,
  payload,
});

actions.clear = () => ({
  type: SESSION.CLEAR,
});
